import Menu from "pages/menuMain/menu";
import React, { useEffect, useContext, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

import Pagination from "../centerComponent/Pagination";
import helper from "services/helper";
import moment from "moment";
import { ReceiptHistoryConcert } from "services/Api/Module/Receipt";
import Submenu2 from "pages/centerComponent/Submenu2";
import EmptyData from "pages/centerComponent/EmptyData";

const DEF_LIMIT = 10;
const DEF_OFFSET = 0;
const CONF_STATUS = {
  0: "ระหว่างพิจารณา",
  1: "ผ่านการตรวจสอบ",
  2: "ไม่ผ่านการตรวจสอบ",
};
const MIN_DATE = "2024-01";
const ReceiptConcert = () => {
  const [receiptHistoryConcert, setReceiptHistoryConcert] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [dateSelect, setDataSelect] = useState(moment().format("YYYY-MM"));
  const navigate = useNavigate();

  const stateProfile = useSelector((state) => state.profile.dataUser);
  const customerId = stateProfile.id;

  let [searchParams, setSearchParams] = useSearchParams();
  const limit = DEF_LIMIT;
  const offset = searchParams.get("offset") ?? DEF_OFFSET;

  const FetchReceiptHistoryConcert = async () => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await ReceiptHistoryConcert({
        params: { customer: customerId, limit, offset, date: dateSelect },
      });
      if (data.resultCode === "20000") {
        const resData = data.resultData;
        const rowCount = data.rowCount;

        _return.status = true;
        _return.result = resData;
        _return.rowCount = rowCount;
      }
    } catch (e) {
      console.log(e);
    }
    return _return;
  };

  const fetchReceiptHistoryConcertList = async () => {
    try {
      const receiptHistoryConcert = await FetchReceiptHistoryConcert();
      console.log(
        "🚀 ~ fetchReceiptHistoryList ~ pointHistory:",
        receiptHistoryConcert
      );
      setReceiptHistoryConcert(receiptHistoryConcert.result);
      setRowCount(receiptHistoryConcert.rowCount);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchReceiptHistoryConcertList();
  }, [stateProfile, offset, dateSelect]);

  return (
    <div>
      <Helmet>
        <title>โคอะลา มาร์ช</title>
        <meta name="title" content="โคอะลา มาร์ช" />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="โคอะลา มาร์ช" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="" />
      </Helmet>

      <div id="pageHistory-Receipt">
        <main>
          <div className="wrapContent">
            <section id="pTitlePage">
              <div className="bTitlePage">
                <a
                  className="btnIconBack"
                  onClick={() => navigate("/profile")}
                ></a>
                <h2>ประวัติการใช้ Point</h2>
              </div>
            </section>
            <Submenu2 />
            <section id="pContent">
              <h1>ประวัติ Receipt concert</h1>
              <div className="bFilter">
                <div className="control-group">
                  <input
                    type="month"
                    name="text"
                    value={dateSelect}
                    min={MIN_DATE}
                    onChange={(e) => {
                      if (MIN_DATE > moment(e.target.value).format("YYYY-MM")) {
                        setDataSelect(moment().format("YYYY-MM"));
                        alert("ไม่พบข้อมูล");
                      } else {
                        setDataSelect(e.target.value);
                      }
                    }}
                  />
                </div>
              </div>
              {rowCount > 0 ? (
                <div className="bCard">
                  <div className="bTablePoint">
                    <table>
                      <thead>
                        <tr>
                          <td>วันที่</td>
                          <td>เลขที่ใบเสร็จ</td>
                          <td>สถานะ</td>
                        </tr>
                      </thead>
                      <tbody>
                        {receiptHistoryConcert.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {item.createdOn
                                  ? helper.TIME.toShortDateNormalTH(
                                      item.createdOn
                                    )
                                  : ""}
                              </td>
                              <td>{item.receiptNo}</td>
                              <td>{CONF_STATUS[item.isApproved]}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    limit={limit}
                    offset={offset}
                    rowCount={rowCount}
                    onBack={(limit, offset) => {
                      console.log(
                        "🚀 ~ CollectPoint ~ limit, offset:",
                        limit,
                        offset
                      );
                      setSearchParams({ offset });
                    }}
                    onNext={(limit, offset) => {
                      console.log(
                        "🚀 ~ CollectPoint ~ limit, offset:",
                        limit,
                        offset
                      );
                      setSearchParams({ offset });
                    }}
                  />
                </div>
              ) : (
                <EmptyData />
              )}
            </section>
          </div>
        </main>
        <Menu />
      </div>
    </div>
  );
};

export default ReceiptConcert;
